var reactAppDataSet = null;

export default function getHtmlDataSet() {
    if (!reactAppDataSet) {
        reactAppDataSet = document.getElementById('react-app').dataset;
    }

    return reactAppDataSet;
}
